import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="address-prefill"
// Listens for company selection changes and pre-fills address fields
// from the selected company's address data.
//
// Only fills fields that are currently blank to avoid overwriting user edits.
//
// Required data attributes:
//   data-address-prefill-url-value: Base URL for fetching company data (e.g., /api/companies)
//
// Targets:
//   address, addressLine2, city, state, zip — the form input fields to fill
//
export default class extends Controller {
  static targets = ["address", "city", "state", "zip"]
  static values = { url: String }

  companyChanged(event) {
    const companyId = event.detail?.value
    if (!companyId) return

    this.fetchAndFillAddress(companyId)
  }

  async fetchAndFillAddress(companyId) {
    try {
      const response = await fetch(`${this.urlValue}/${companyId}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) return

      const company = await response.json()

      this.fillIfBlank("address", company.address)
      this.fillIfBlank("city", company.city)
      this.fillIfBlank("state", company.state)
      this.fillIfBlank("zip", company.zip)
    } catch (error) {
      // Silently fail — address prefill is a convenience, not critical
    }
  }

  fillIfBlank(targetName, value) {
    const target = `${targetName}Target`
    if (this[`has${targetName.charAt(0).toUpperCase() + targetName.slice(1)}Target`] && !this[target].value.trim()) {
      this[target].value = value || ""
    }
  }
}
